import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Table from "../../components/generalComponents/Table";
import { fetchBasket } from "../../services/basket/actions";
import { changeDeliveryOptionBody } from "../../services/currentInformation/actions";
import {
	fetchBalance,
	fetch_discount_info,
	placeOrder,
} from "../../services/placeOrder/actions";
import { calculateBasketTotal, formatPrice } from "../../utils/priceUtils";

const DEFAULT_KORTING_BODY = {
	//put it back to default
	kortingscode: "AAAAA",
	value: 0,
	type: "amount",
	shipping: false,
};

function confirmOrder(props) {
	const [balance, setBalance] = useState(0);
	const [usedBalance, setUsedBalance] = useState(0);
	const [remainderAfterBalance, setRemainderAfterBalance] = useState(0);
	const [remainderAfterDiscount, setRemainderAfterDiscount] = useState(0);
	const [usedDiscount, setUsedDiscount] = useState(0);
	const location = useLocation();
	const history = useHistory();
	const [isCheckedBalance, setisCheckedBalance] = useState(true);
	const [isCheckedKortingscode, setIsCheckedKortingscode] = useState(false);
	const [kortingsCode, setKortingcode] = useState(null);
	const [discountMessage, setDiscountMessage] = useState(null);
	const [discountInfo, setDiscountInfo] = useState(DEFAULT_KORTING_BODY);
	const [totalAmountPreDiscount, setTotalAmountPreDiscount] = useState(0);

	const { orderBody, locationName } = props.deliveryOptionBody || {};

	const calculateRemainderAfterBalance = () => {
		//var basket_total = calculateBasketTotal(props.basketProducts);
		if (isCheckedBalance) {
			if (balance / 100 > remainderAfterDiscount) {
				setUsedBalance(remainderAfterDiscount);
				setRemainderAfterBalance(formatPrice(0, "Euro"));
			} else {
				setUsedBalance(balance);
				setRemainderAfterBalance(
					formatPrice(remainderAfterDiscount - balance / 100, "Euro")
				);
			}
		} else {
			setUsedBalance(0);
			setRemainderAfterBalance(formatPrice(remainderAfterDiscount, "Euro"));
		}
	};

	const calculateRemainderAfterDiscount = () => {
		if (discountInfo) {
			if (discountInfo.type == "amount") {
				if (discountInfo.value > totalAmountPreDiscount) {
					setUsedDiscount(totalAmountPreDiscount);
					setRemainderAfterDiscount(0);
				} else {
					setUsedDiscount(discountInfo.value);
					setRemainderAfterDiscount(
						totalAmountPreDiscount - discountInfo.value
					);
				}
			} else if (discountInfo.type == "percentage") {
				setUsedDiscount((discountInfo.value / 100) * totalAmountPreDiscount);
				setRemainderAfterDiscount(
					totalAmountPreDiscount -
						(discountInfo.value / 100) * totalAmountPreDiscount
				);
			} else {
				console.log("Wrong discount type is given");
			}
		}
	};

	useEffect(() => {
		fetchBasket(props.currentLocation.id, props.userId);
	}, [props.currentLocation.id]);

	useEffect(() => {
		let total = calculateBasketTotal(props.basketProducts);
		//var basket_total = calculateBasketTotal(props.basketProducts);
		if (orderBody?.delivery && discountInfo.shipping == false) {
			total = parseFloat(total) + parseFloat(orderBody.delivery_costs);
		}
		setTotalAmountPreDiscount(total);
	}, [props.basketProducts, orderBody, discountInfo.shipping]);

	useEffect(() => {
		fetchBalance(props.userId, setBalance);
	}, []);

	useEffect(() => {
		calculateRemainderAfterBalance();
	}, [isCheckedBalance, balance, remainderAfterDiscount]);

	useEffect(() => {
		calculateRemainderAfterDiscount();
	}, [discountInfo.kortingscode, totalAmountPreDiscount]);

	const showDeliveryInfo = () => {
		if (props.deliveryOptionBody) {
			if (orderBody?.pickup) {
				// Pickup
				return (
					<div align="center">
						<p style={{ fontWeight: "bold" }}>{locationName}</p>
						<p>
							{orderBody.deliveryDate +
								" " +
								orderBody.open +
								"-" +
								orderBody.close}
						</p>
					</div>
				);
			} else if (orderBody?.delivery) {
				// Delivery
				return (
					<div align="center">
						<p>
							{orderBody.deliveryDate +
								" " +
								orderBody.from +
								"-" +
								orderBody.until}
						</p>
					</div>
				);
			} else {
				// Zakelijk
				return <p align="center">{orderBody?.deliveryDate}</p>;
			}
		} else {
			return null;
		}
	};

	const handleCheckBoxDiscount = () => {
		setIsCheckedKortingscode(!isCheckedKortingscode);
	};

	useEffect(() => {
		if (isCheckedKortingscode == false) {
			setDiscountMessage(null);
			setDiscountInfo(DEFAULT_KORTING_BODY);
			setRemainderAfterDiscount(totalAmountPreDiscount);
			setKortingcode(null);
		}
	}, [isCheckedKortingscode]);

	const handleChangeCheckBox = (event) => {
		discountInfo.test = "YO";
		setisCheckedBalance(!isCheckedBalance);
	};

	const handleSubmitKortingscode = () => {
		fetch_discount_info(
			kortingsCode,
			props.identifyInfo.marketplace,
			props.userId,
			setDiscountInfo,
			setDiscountMessage
		);
	};

	const handleOrderClick = () => {
		if (isCheckedBalance && balance > 0) {
			orderBody.used_balance = usedBalance;
		}
		if (orderBody) {
			placeOrder(orderBody);
			// placeOrder(orderBody, props.payOnline); // Zet aan voor Mollie
			props.changeDeliveryOptionBody({});
		} else {
			alert("Er is iets misgegaan, kies opnieuw uw levering");
			history.push("/order_delivery_choice");
		}
	};

	const basketColumnsTable = [
		{ name: "Naam", dataName: "name" },
		{ name: "Prijs", dataName: "salesprice" },
		{
			name: "Aantal",
			dataName: "numberShowOnly",
			component: "ProductAmountAcount",
			type: "confirmOrder",
		},
		{ name: "Bedrag", dataName: "totalPrice", component: "calculateTotal" },
	];

	return (
		<div>
			<h3 align="center">U bestelt voor: {props.currentLocation.name}</h3>
			{showDeliveryInfo()}
			<Table
				data={props.basketProducts}
				columnsMapping={basketColumnsTable}
				orderConfirmation="true"
			/>
			<hr />
			<h3 align="center">
				{"Subtotaal: " +
					formatPrice(calculateBasketTotal(props.basketProducts), "Euro")}
			</h3>
			{orderBody?.delivery && (
				<h4 align="center">
					{`Verzendkosten: ${formatPrice(orderBody.delivery_costs, "EUR")}`}
				</h4>
			)}
			<div align="center">
				<FormControlLabel
					control={
						<Checkbox
							color="primary"
							checked={isCheckedKortingscode}
							onChange={handleCheckBoxDiscount}
							inputProps={{
								"aria-label": "primary checkbox",
							}}
						/>
					}
					label="Ik heb een kortingscode"
				/>
				{isCheckedKortingscode && (
					<div align="center">
						<form onSubmit={handleSubmitKortingscode}>
							<input
								placeholder="Kortingscode"
								onChange={(e) => setKortingcode(e.target.value)}
							></input>
						</form>
						<h4>{discountMessage}</h4>
					</div>
				)}
				{balance > 0 && (
					<FormControlLabel
						control={
							<Checkbox
								color="primary"
								checked={isCheckedBalance}
								onChange={handleChangeCheckBox}
								inputProps={{
									"aria-label": "primary checkbox",
								}}
							/>
						}
						label={`Gebruik mijn ${formatPrice(
							balance,
							"Euro",
							true
						)} aan saldo`}
					/>
				)}
			</div>

			<h2 align="center">{"Totaalbedrag: " + remainderAfterBalance}</h2>

			<div align="center">
				<Button color="primary" variant="contained" onClick={handleOrderClick}>
					Plaats Bestelling
				</Button>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => ({
	basketProducts: state.basket.products,
	userId: state.login.data.user_id,
	currentLocation: state.currentInformation.current_location,
	business: state.login.data.business,
	identifyInfo: state.identify.identifyInfo,
	deliveryOptionBody: state.currentInformation.delivery_option_body,
	payOnline: state.login.data.pay_online,
});

export default connect(mapStateToProps, {
	fetchBasket,
	changeDeliveryOptionBody,
})(confirmOrder);
